module.exports = __webpack_public_path__ + "static/img/ico_guanli.dd51978.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_guanli.jpg
// module id = x3id
// module chunks = 1